export const editableSections = ['A', 'B', 'C', 'G', 'H', 'F', 'E'];
